import { Link } from 'react-router-dom';
import { Facebook, Twitter, Instagram, Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 text-white mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-8">
          {/* About */}
          <div className="space-y-4">
            <div className="flex items-center space-x-3">
              <div className="w-12 h-12 rounded-full overflow-hidden shadow-md">
                <img 
                  src="/logo.jpg" 
                  alt="Alliance Solidarité" 
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="text-lg font-bold">Alliance Solidarité</div>
            </div>
            <p className="text-sm text-gray-400">
              Connecter les initiatives solidaires pour construire ensemble un monde meilleur.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Liens Rapides</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/carte" className="text-gray-400 hover:text-emerald-400 transition-colors">
                  Carte Interactive
                </Link>
              </li>
              <li>
                <Link to="/ajouter" className="text-gray-400 hover:text-emerald-400 transition-colors">
                  Ajouter une Offre
                </Link>
              </li>
              <li>
                <Link to="/login" className="text-gray-400 hover:text-emerald-400 transition-colors">
                  Connexion
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Mentions Légales</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/mentions-legales" className="text-gray-400 hover:text-emerald-400 transition-colors">
                  Mentions Légales
                </Link>
              </li>
              <li>
                <Link to="/politique-confidentialite" className="text-gray-400 hover:text-emerald-400 transition-colors">
                  Politique de Confidentialité
                </Link>
              </li>
              <li>
                <Link to="/cgu" className="text-gray-400 hover:text-emerald-400 transition-colors">
                  CGU
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Contact</h3>
            <ul className="space-y-3">
              <li className="flex items-center gap-2 text-gray-400">
                <MapPin className="w-4 h-4 text-emerald-400" />
                <span className="text-sm">32, Allée Bajou, 94230 Cachan</span>
              </li>
              <li className="flex items-center gap-2 text-gray-400">
                <Phone className="w-4 h-4 text-emerald-400" />
                <span className="text-sm">06 41 95 65 75</span>
              </li>
              <li className="flex items-center gap-2 text-gray-400">
                <Mail className="w-4 h-4 text-emerald-400" />
                <span className="text-sm">contact@alliance-solidarite.org</span>
              </li>
            </ul>
          </div>

          {/* Social */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Suivez-nous</h3>
            <div className="flex space-x-4">
              <a
                href="#"
                className="w-10 h-10 bg-slate-700 hover:bg-purple-500 rounded-full flex items-center justify-center transition-colors"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-slate-700 hover:bg-red-500 rounded-full flex items-center justify-center transition-colors"
              >
                <Twitter className="w-5 h-5" />
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-slate-700 hover:bg-yellow-500 rounded-full flex items-center justify-center transition-colors"
              >
                <Instagram className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-slate-700 mt-8 pt-8 text-center">
          <p className="text-sm text-gray-400">&copy; {new Date().getFullYear()} Alliance Solidarité - L'Alliance Humaine 2020. Tous droits réservés.</p>
          <p className="text-xs text-gray-500 mt-2">Association loi 1901 - SIREN: 888 686 904</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;